import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const ArrowDown: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M17.3266 3.06337V23.8501l6.6934-6.6934c.52-.52 1.36-.52 1.88 0 .52.52.52 1.36 0 1.88l-9.9067 9.9067-9.90662-9.9067c-.26667-.2666-.38667-.6-.38667-.9466 0-.3467.13334-.68.38667-.9467.52-.52 1.36-.52 1.88 0L14.66 23.8367V3.05005h2.6666v.01332Z"
    />
  </Icon>
);
